(() => {
  if (window.__cfAtcPatched) return;
  window.__cfAtcPatched = true;

  let lastBtn = null;

  document.addEventListener("click", (e) => {
    const btn = e.target.closest(".cf-atc-btn");
    if (!btn) return;
    lastBtn = btn;
    if (!btn.dataset.cfLabel) btn.dataset.cfLabel = btn.textContent.trim();
  });

  const originalFetch = window.fetch;

  window.fetch = async (...args) => {
    const res = await originalFetch(...args);

    try {
      const url = typeof args[0] === "string" ? args[0] : (args[0]?.url || "");
      const isAddToCart = url.includes("/cart/add") || url.includes("/cart/add.js");

      if (isAddToCart && res.ok) {

        if (lastBtn) {
          const btn = lastBtn;
          const original = btn.dataset.cfLabel || btn.textContent.trim();

          if (btn.dataset.cfTimer) {
            window.clearTimeout(Number(btn.dataset.cfTimer));
          }

          btn.classList.add("is-added");
          btn.textContent = "Added ✓";

          const t = window.setTimeout(() => {
            btn.textContent = original;
            btn.classList.remove("is-added");
            delete btn.dataset.cfTimer;
          }, 1400);

          btn.dataset.cfTimer = String(t);
          lastBtn = null;
        }

        const cartDrawer =
          document.querySelector('details[id^="Details-CartDrawer"]');

        if (cartDrawer) {
          const summary = cartDrawer.querySelector("summary");
          if (summary) summary.click();
        }
      }

    } catch (err) {}

    return res;
  };
})();